import React from "react";
import { useTranslation } from "react-i18next";
import { OcCard, OcCardLabel, OcInfoCardItem } from "oc/components";
import getCountryName from "oc/utils/get-country-name";

interface Address {
  country?: string;
  city?: string;
  zip?: string;
  streetName?: string;
  streetType?: { name?: string };
  streetNumber?: string;
  building?: string;
  stairway?: string;
  floor?: string;
  door?: string;
  district?: string;
}

interface OcInfoCardAddressProps {
  address: Address;
  label?: string;
  translation?: string;
  def?: string;
  onEdit?: (address?: string) => void;
  isEditButtonDisabled?: boolean;
  editable?: boolean;
  defaultLabel?: string;
}

export const OcInfoCardAddress: React.FC<OcInfoCardAddressProps> = ({
  address,
  label,
  translation,
  def,
  onEdit,
  isEditButtonDisabled,
  editable,
  defaultLabel,
}) => {
  const { t, i18n } = useTranslation();

  const getFullAddress = ({ address }: { address: Address }) => {
    let result = "";
    result = address?.streetName ? result + " " + address?.streetName : result;
    result = address?.streetType?.name
      ? result + " " + address?.streetType?.name
      : result;
    result = address?.streetNumber
      ? result + " " + address?.streetNumber
      : result;
    result = address?.building ? result + " " + address?.building : result;
    result = address?.stairway ? result + " " + address?.stairway : result;
    result = address?.floor ? result + " " + address?.floor : result;
    result = address?.door ? result + " " + address?.door : result;
    return result?.trim();
  };

  const isEmptyAddress = ({ address }: { address: Address }) => {
    if (
      address?.country === "" &&
      address?.city === "" &&
      address?.zip === "" &&
      getFullAddress({ address }) === ""
    )
      return true;
    return false;
  };

  if (isEmptyAddress({ address })) return null;

  const parsedLabel = defaultLabel || translation || label || "";

  return (
    <OcCard
      label={
        <OcCardLabel
          label={t(parsedLabel)}
          translation={translation || ""}
          editable={editable ?? false}
          def={{ address: def }}
          onEdit={() => onEdit?.()}
          isEditButtonDisabled={isEditButtonDisabled ?? false}
        />
      }
    >
      <>
        <OcInfoCardItem
          label={t("MY_HR_COUNTRY") || ""}
          value={getCountryName(address?.country ?? "", i18n?.language ?? "en")}
          translation={translation}
        />
        <OcInfoCardItem
          label={t("MY_HR_ZIP") || ""}
          value={address?.zip}
          translation={translation}
        />
        <OcInfoCardItem
          label={t("MY_HR_CITY") || ""}
          value={address?.city}
          translation={translation}
        />
        <OcInfoCardItem
          label={t("MY_HR_DISTRICT") || ""}
          value={address?.district}
          translation={translation}
        />
        <OcInfoCardItem
          label={t("MY_HR_ADDRESS") || ""}
          value={getFullAddress({ address })}
          translation={translation}
        />
      </>
    </OcCard>
  );
};

export default OcInfoCardAddress;
